<template>
  <b-form-group label-cols="2" horizontal label="이용가능 매장">
    <b-row>
      <b-col cols="8">
        <div class="ex-lib">
<!--          <p>-->
<!--            {{ _storeCodes }}-->
<!--          </p>-->
<!--          <p>-->
<!--            {{ storeNewArr }}-->
<!--          </p>-->
<!--          <vue-select-sides type="mirror" v-model="_storeCodes" style="height: 300px" :sort-selected-up="false"-->
<!--                            :search="false" :toggle-all="true" :list="storeNewArr" :total="showTotal"-->
<!--                            :placeholder-search-left="leftPlaceholder"-->
<!--                            :placeholder-search-right="rightPlaceholder"></vue-select-sides>-->
          <div class="selBox" style="height: 280px">
            <div class="noSelectStores">
              <ul>
                <li v-for="(item, idx) in noSelectStores" :key="idx" @click="moveClick(item, 'noSelectStores', idx)">
                  {{ item.label }}
                </li>
              </ul>
            </div>
            <div class="vss-span"> ‹ ›</div>
            <div class="selectStores">
              <ul>
                <li v-for="(item, idx) in selectStores" :key="idx" @click="moveClick(item,'selectStores', idx)">
                  {{ item.label }}
                </li>
              </ul>
            </div>
          </div>
          <!-- {{_storeCodes }} -->
        </div>
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import vueSelectSides from "vue-select-sides";
import "vue-select-sides/styles/themes/light.scss";
import api from '../../../../constants/api';
import EventBus from '../../../../utils/EventBus';

import {
  mapGetters,
  mapMutations
} from "vuex";

export default {
  components: {
    vueSelectSides,
  },
  data() {
    return {
      storeList: [],
      order: "asc",
      showTotal: true,
      leftPlaceholder: "매장명 검색...",
      rightPlaceholder: "매장명 검색...",
      stopStoreCodeSet: false,
      storeNewArr: [],
      selectStores: [],
      noSelectStores: [],
      forTheFirstMounted: false,
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName', 'goodsType', 'hasSalesPeriod', 'saleEndDate', 'saleStartDate', 'expirationDateSetting', 'validDayCount', 'validFromDate', 'validToDate', 'cancellableTimeSetting', 'cancellableTimeValue', 'storeCodes']),
    _storeCodes: {
      get: function () {
        console.log(this.storeCodes)
        return this.storeCodes
      },
      set: function (e) {
        if (Object.keys(e).length === 0) {
          return;
        }
        if (this.stopStoreCodeSet) {
          this.stopStoreCodeSet = false;
          return;
        }
        // console.log(this._storeCodes);
        // console.log(this.storeNewArr)
        this.setStoreCodes(e);
      }
    }
  },
  watch:{
    storeCodes(val){
      console.log(val)
      if(!this.forTheFirstMounted){
        this.loadStore(val);
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      console.log(this.$router.currentRoute.fullPath.includes('goods-register-request'))
      let lastStrNumber = this.$router.currentRoute.fullPath;
      console.log(Number(lastStrNumber[lastStrNumber.length - 1]))
      console.log()
      if(this.$router.currentRoute.fullPath.includes('goods-register-request') && this.$router.currentRoute.params.registerId === undefined){
        this.loadStore();
      }
    })


  },
  created() {
    EventBus.$on('setStore', () => {
      EventBus.$emit('storelistBus', this.storeNewArr, this._storeCodes);
      // console.log(this._storeCodes)

    });

  },

  methods: {
    ...mapMutations(['setStoreCodes']),
    moveClick(item, type, idx) {
      if (type === 'selectStores') {
        this.selectStores.splice(idx, 1);
        this.noSelectStores.push(item)
      } else {
        this.noSelectStores.splice(idx, 1);
        this.selectStores.push(item)
      }
      let storeCodesNew = [];
      for (const idx in this.selectStores) {
        storeCodesNew.push(this.selectStores[idx].value);
      }
      // this._storeCodes = storeCodesNew;
      this.setStoreCodes(storeCodesNew);
      console.log(storeCodesNew)
      // let result = [...new Set([...this.selectStores, ...this.noSelectStores])];
      // // console.log(result)
      // this.storeNewArr = result;
      console.log(storeCodesNew);
    },
    loadStore(val) {
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.brandStoreCode)
      this.$http.get(reqURL, {
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {

          let vm = this
          let storeCodes = [];
          res.data.data.forEach(function (value, index) {
            if (value.enabled) {
              storeCodes.push(value.storeCode)
              vm.storeList.push({
                label: value.storeName,
                value: value.storeCode
              })
            }
          })
          console.log('vm.storeList')
          console.log(val)
          let storeCodesCopy = [];
          let nesGoods = false;
          if(val){
            storeCodesCopy = val;
            nesGoods = false;
          }else{
            storeCodesCopy = storeCodes;
            nesGoods = true;
          }

          // console.log('storeCodesCopy')
          // console.log(storeCodesCopy)
          storeCodesCopy.forEach(function (val, index) {
            vm.storeList.forEach(function (v, i) {
              if (val === v.value) {
                vm.storeNewArr.push({
                  label: v.label,
                  value: v.value
                })
                vm.selectStores.push({
                  label: v.label,
                  value: v.value
                })
              }
            })
          })

          console.log('vm.storeNewArr')
          console.log(vm.storeNewArr)
          let filterArr = [];
          vm.storeList.forEach((item, idx) => {
            for (const idxs in vm.storeNewArr) {
              if(vm.storeNewArr.findIndex(v => v.value === item.value) == -1){
                filterArr.push(item) ;
              }
            }
          })
          console.log('soreListAdd');
          console.log(filterArr);
          if(val === undefined){
            vm.noSelectStores = vm.storeList;
            vm.selectStores = [];
          }else{
            vm.noSelectStores = [...new Set(filterArr)];
          }



          let result = [...new Set([...vm.storeNewArr, ...vm.noSelectStores])];
          // console.log(result)
          vm.storeNewArr = result;

          this.stopStoreCodeSet = true;
          this.forTheFirstMounted = true;

          EventBus.$emit('storelistBus', vm.storeNewArr, vm._storeCodes);
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

    }
  }

}
</script>

<style scoped>
.noSelectStores ul li {
  list-style: none;
  cursor: pointer;
  background-color: #fafafa;
  border: 1px solid whitesmoke;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
}

.selectStores ul li {
  list-style: none;
  background-color: #e9e9e9;
  color: #6f6f6f;
  border-color: transparent;
  cursor: pointer;
  border: 1px solid whitesmoke;
  padding: 5px;
  margin: 5px;
  border-radius: 5px;
}

.noSelectStores {
  display: inline-block;
  vertical-align: top;
  -webkit-box-shadow: 0px 0px 10px #e1e1e1;
  box-shadow: 0px 0px 10px #e1e1e1;
  border-radius: 0.25rem;
  width: 47%;
  padding: 4px;
  overflow: auto;
}


.noSelectStores ul, .selectStores ul {
  margin: 0;
  padding: 0;
}

.noSelectStores ul li, .selectStores ul li {
  padding: 5px 15px;
}


.selectStores {
  display: inline-block;
  vertical-align: top;
  -webkit-box-shadow: 0px 0px 10px #e1e1e1;
  box-shadow: 0px 0px 10px #e1e1e1;
  border-radius: 0.25rem;
  width: 47%;
  padding: 4px;
  overflow: auto;
}

.selBox {
  display: flex;
  justify-content: space-between;
}

.vss-span {
  vertical-align: middle;
  padding-top: 10%;
}
</style>
